import { BasePayloadMapper } from '@ps/utils';
import { SurveyPatchPayloadDto } from '../dtos/survey.dto';

export interface SurveyUrlsPatch {
  readonly liveUrl: string;
  readonly testUrl: string;
}

export class SurveyUrlsPatchPayloadMapper extends BasePayloadMapper<
  SurveyUrlsPatch,
  SurveyPatchPayloadDto[]
> {
  public toPayload({
    liveUrl,
    testUrl,
  }: SurveyUrlsPatch): SurveyPatchPayloadDto[] {
    return [
      { op: 'replace', path: '/live_url', value: liveUrl },
      // No test URL of its own — respondents test through the live URL instead.
      { op: 'replace', path: '/test_url', value: testUrl || liveUrl },
    ];
  }
}
